import { GlobalFilter } from '../global/GlobalFilter';
import { sortDataList } from './sortDataList';
export class ListDataFilter extends GlobalFilter {
  orderBy!: sortDataList;
  LabName!: string;
  // caseIdType!: CaseType;
  CaseIds!: number[];
  LabType!: string;
  CountryId!: string;
  RegionId!: string;
  CityId!: string;
  EntityId!: string;
  EntityType!: string;
  IsDiagnoseOnly!: boolean;
  forGrossing!: boolean;
}
